import React, { FC } from 'react';
import { ProductModel } from '../../../shared/orders';
import { RegistrationInfo } from '../../../shared/registration/model';
import { AddedToCart, AddedToCartCheck, RichMarkdownIt, SecondaryAction } from '../../components';
import { useTranslation } from '../../translations';
import { Fetcher, useFetcher } from '../../utils/useFetcher';
interface Props {
  readonly product: ProductModel;
  readonly registration?: RegistrationInfo;
}

const secondaryAction: SecondaryAction = { to: '/event/register', text: 'add_more_registrations' };

export const EventRegistrationComplete: FC<Props> = ({ product, registration }) => {
  const { ts } = useTranslation();

  const raffleFetch = useFetcher(async () => {
    if (product.raffle) {
      return await api.getRaffleById(product.raffle.id);
    }

    return undefined;
  }, [registration]);

  if (registration && registration.paidOrderItem?.productId === product.id) {
    return (
      <AddedToCart
        id="registrationSaved"
        product={product}
        secondaryAction={secondaryAction}
        subtext={<p>{ts('your_badge_information_has_been')}</p>}
        title={ts('registration_saved')}
      />
    );
  }

  if (product.raffle) {
    if (!raffleFetch.success) {
      return <Fetcher result={raffleFetch} />;
    }

    const status = raffleFetch.data!.ticket?.status;

    if (status !== 'winner' && status !== 'redeemed' && !product.raffle.roleOverride) {
      // If volunteerOverride is false, or user isn't a volunteer or staff member
      return (
        <AddedToCart
          id="cartEnteredRaffle"
          product={product}
          secondaryAction={secondaryAction}
          subtext={<RichMarkdownIt source={product.raffle.enteredSubtext} />}
          title={product.raffle.enteredTitle}
        />
      );
    }
  }

  return <AddedToCartCheck product={product} secondaryAction={secondaryAction} />;
};
